<template>
  <div>
    <!-- <v-card class="ma-5 font-weight-light" elevation="0"> -->
    <v-row class="mx-1">
      <v-col class="display-1 font-weight-bold"> User groups</v-col>
      <!--
      <v-col class="ml-5 xs-full-width text-right">
        <v-btn
          elevation="0"
          @click="openDialog(null, '', null, 1)"
          class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
        >
          <v-icon left>mdi-plus</v-icon>
          {{ $vuetify.lang.t("$vuetify.userGroupManagement.addGroup") }}
        </v-btn>
      </v-col>
      -->
    </v-row>
    <v-card
      class="ma-5 font-weight-light card-bg"
      elevation="0"
      v-if="groups.length != 0"
    >
      <draggable
        :list="groups"
        :disabled="!enabled"
        class="list-group"
        ghost-class="ghost"
        @end="checkMoveRootGroup()"
      >
        <div
          class="card-list mb-12"
          v-for="(itemGroup, index) in groups"
          :key="index"
        >
          <v-card
            outlined
            elevation="0"
            class="mt-4 py-0 card-custom-lecture"
            width="100%"
          >
            <v-list-item>
              <v-list-item-avatar class="my-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
                      <v-icon>mdi-drag-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <span class="subtitle-1">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.dragToMoveSequence'
                    )
                  }}</span>
                </v-tooltip>
              </v-list-item-avatar>

              <v-list-item-content class="pa-0">
                <v-list-item-title>
                  {{ itemGroup.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <!-- {{ itemGroup.countCourse }} -->
                  {{ itemGroup.totalCourse }}
                  {{ $vuetify.lang.t('$vuetify.userGroupManagement.course') }} /
                  <!-- {{ itemGroup.countStudent }} -->
                  {{ itemGroup.totalStudent }}
                  {{ $vuetify.lang.t('$vuetify.userGroupManagement.learner') }}
                </v-list-item-subtitle>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click="openExpand(index)"
                      icon
                      class="md-position-absolute centerx-ele mt-2 active"
                      :id="`centerx-ele-${index}`"
                    >
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <span class="subtitle-1">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.clickToHideOrShow'
                    )
                  }}</span>
                </v-tooltip>
              </v-list-item-content>
              <v-list-item-action>
                <v-row align="center" justify="end">
                  <div class="d-flex align-center">
                    <span
                      v-if="itemGroup.active"
                      class="primary--text subtitle-1 font-italic font-weight-light"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.publish'
                        )
                      }}</span
                    >
                    <span
                      v-else
                      class="font-italic subtitle-1 font-weight-light"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.disable'
                        )
                      }}</span
                    >
                    <v-switch
                      :disabled="
                        itemGroup.isUse == true ||
                        itemGroup.countCourse != 0 ||
                        itemGroup.countStudent != 0
                      "
                      inset
                      v-model="itemGroup.active"
                      class="px-6"
                      color="primary"
                      @click="openDialogStatus(itemGroup, null, null, 1)"
                    ></v-switch>
                  </div>
                  <v-btn
                    elevation="0"
                    class="body-2 text-primary text-capitalize"
                    color="white"
                    @click="openDialog(itemGroup._id, '', itemGroup, 2)"
                  >
                    <v-icon left> mdi-plus </v-icon
                    >{{ $vuetify.lang.t('$vuetify.userGroupManagement.add') }}
                    <!-- {{ $vuetify.lang.t("$vuetify.userGroupManagement.addGroup") }} -->
                  </v-btn>
                  <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        elevation="0"
                        class="mb-0 body-2 text-primary text-capitalize"
                        color="white"
                      >
                        <!-- <v-icon left>mdi-cog</v-icon> -->
                        {{
                          $vuetify.lang.t('$vuetify.userGroupManagement.option')
                        }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        :disabled="
                          itemGroup.child_User_Group.length != 0 ||
                          itemGroup.countCourse != 0 ||
                          itemGroup.countStudent != 0 ||
                          itemGroup.active == true
                        "
                        @click="openDialogChangeRoot(itemGroup, itemGroup, 1)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon
                            small
                            :color="
                              itemGroup.child_User_Group.length != 0 ||
                              itemGroup.countCourse != 0 ||
                              itemGroup.countStudent != 0 ||
                              itemGroup.active == true
                                ? 'grey lighten-1'
                                : ''
                            "
                            >mdi-arrow-split-horizontal</v-icon
                          >
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.userGroupManagement.changeRoot'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item
                        @click="
                          openDialog(
                            itemGroup._id,
                            itemGroup.title,
                            itemGroup,
                            1
                          )
                        "
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small> mdi-square-edit-outline </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.userGroupManagement.edit'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item
                        :disabled="
                          itemGroup.child_User_Group.length != 0 ||
                          itemGroup.countCourse != 0 ||
                          itemGroup.countStudent != 0 ||
                          itemGroup.active == true
                        "
                        @click="deleteGroupDialog(itemGroup._id)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon
                            small
                            :color="
                              itemGroup.child_User_Group.length != 0 ||
                              itemGroup.countCourse != 0 ||
                              itemGroup.countStudent != 0 ||
                              itemGroup.active == true
                                ? 'grey lighten-1'
                                : 'error'
                            "
                            >mdi-delete</v-icon
                          >
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            :class="
                              itemGroup.child_User_Group.length != 0 ||
                              itemGroup.countCourse != 0 ||
                              itemGroup.countStudent != 0 ||
                              itemGroup.active == true
                                ? 'font-weight-light subtitle-2'
                                : 'font-weight-light subtitle-2 error--text'
                            "
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.userGroupManagement.delete'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </v-card>
          <!-- sub group -->
          <v-card outlined elevation="0" class="mt-0 card-child-lecture">
            <div
              class="expand-panel active lesson-card mt-0 pt-2"
              :id="`expand-${index}`"
            >
              <p
                class="subtitle-1 text-center blue-grey--text my-3"
                v-if="itemGroup.child_User_Group.length == 0"
              >
                {{ $vuetify.lang.t('$vuetify.userGroupManagement.noGroup') }}
              </p>
              <v-divider
                v-if="itemGroup.child_User_Group.length == 0"
                class="ma-0"
              ></v-divider>
              <draggable
                :list="itemGroup.child_User_Group"
                :disabled="!enabled"
                ghost-class="ghost"
                @end="checkMoveGroup()"
              >
                <div
                  v-for="child in itemGroup.child_User_Group"
                  :key="child._id"
                >
                  <!-- <template v-slot:activator> -->
                  <v-list-item class="pl-8">
                    <v-list-item-avatar class="my-0">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon>mdi-drag-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <span class="subtitle-1">{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.dragToMoveSequence'
                          )
                        }}</span>
                      </v-tooltip>
                      <!-- <div>
                        <template>
                          <v-icon> mdi-minus </v-icon>
                        </template>
                      </div> -->
                    </v-list-item-avatar>
                    <v-list-item-content class="pa-0">
                      <v-list-item-title
                        v-text="child.title"
                      ></v-list-item-title>
                      <v-list-item-subtitle>
                        {{ child.countCourse }}
                        {{
                          $vuetify.lang.t('$vuetify.userGroupManagement.course')
                        }}
                        / {{ child.countStudent }}
                        {{
                          $vuetify.lang.t(
                            '$vuetify.userGroupManagement.learner'
                          )
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row align="center" justify="end">
                        <div class="d-flex align-center">
                          <span
                            v-if="child.active"
                            class="primary--text subtitle-1 font-italic font-weight-light"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.publish'
                              )
                            }}</span
                          >
                          <span
                            v-else
                            class="font-italic subtitle-1 font-weight-light"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.disable'
                              )
                            }}</span
                          >
                          <v-switch
                            inset
                            v-model="child.active"
                            class="px-6"
                            color="primary"
                            @click="openDialogStatus(itemGroup, child, null, 2)"
                            :disabled="
                              itemGroup.isUse == true ||
                              itemGroup.active == false ||
                              child.countCourse != 0 ||
                              child.countStudent != 0
                            "
                          ></v-switch>
                        </div>
                        <!-- <v-divider inset vertical class="mb-2 mx-1"></v-divider> -->
                        <v-btn
                          elevation="0"
                          class="body-2 text-primary text-capitalize"
                          color="white"
                          @click="openDialog(child._id, '', child, 3)"
                        >
                          <v-icon left>mdi-plus</v-icon
                          >{{
                            $vuetify.lang.t('$vuetify.userGroupManagement.add')
                          }}
                          <!-- {{ $vuetify.lang.t("$vuetify.userGroupManagement.addGroup") }} -->
                        </v-btn>
                        <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                            >
                              <!-- <v-icon left>mdi-cog</v-icon> -->
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.userGroupManagement.option'
                                )
                              }}
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              :disabled="child.active == true"
                              @click="openDialogChangeRoot(itemGroup, child, 2)"
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon
                                  small
                                  :color="
                                    child.active == true ? 'grey lighten-1' : ''
                                  "
                                  >mdi-arrow-split-horizontal</v-icon
                                >
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-light subtitle-2"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.userGroupManagement.changeRoot'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item
                              @click="
                                openDialog(child._id, child.title, child, 2)
                              "
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon small> mdi-square-edit-outline </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-light subtitle-2"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.userGroupManagement.edit'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item
                              :disabled="
                                child.child_User_Group.length != 0 ||
                                child.countCourse != 0 ||
                                child.countStudent != 0 ||
                                child.active == true
                              "
                              @click="deleteGroupDialog(child._id)"
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon
                                  small
                                  :color="
                                    child.child_User_Group.length != 0 ||
                                    child.countCourse != 0 ||
                                    child.countStudent != 0 ||
                                    child.active == true
                                      ? 'grey lighten-1'
                                      : 'error'
                                  "
                                  >mdi-delete</v-icon
                                >
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  :class="
                                    child.child_User_Group.length != 0 ||
                                    child.countCourse != 0 ||
                                    child.countStudent != 0 ||
                                    child.active == true
                                      ? 'font-weight-light subtitle-2'
                                      : 'font-weight-light subtitle-2 error--text'
                                  "
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.userGroupManagement.delete'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>

                  <draggable
                    :list="child.child_User_Group"
                    :disabled="!enabled"
                    ghost-class="ghost"
                    @end="checkMoveGroup()"
                  >
                    <div
                      v-for="child2 in child.child_User_Group"
                      :key="child2._id"
                    >
                      <v-list-item class="pl-16">
                        <v-list-item-avatar class="my-0">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on">
                                <v-icon small color="grey lighten-1"
                                  >mdi-drag-horizontal</v-icon
                                >
                              </v-btn>
                            </template>
                            <span class="subtitle-1">{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.dragToMoveSequence'
                              )
                            }}</span>
                          </v-tooltip>
                          <!-- <div v-if="child2.child_User_Group.length == 0">
                            <template>
                              <v-icon> mdi-minus </v-icon>
                            </template>
                          </div> -->
                        </v-list-item-avatar>
                        <v-list-item-content class="pl-0 py-0 pr-0">
                          <v-list-item-title
                            v-text="child2.title"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            {{ child2.countCourse }}
                            {{
                              $vuetify.lang.t(
                                '$vuetify.userGroupManagement.course'
                              )
                            }}
                            / {{ child2.countStudent }}
                            {{
                              $vuetify.lang.t(
                                '$vuetify.userGroupManagement.learner'
                              )
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-row align="center" justify="end">
                            <div class="d-flex align-center">
                              <span
                                v-if="child2.active"
                                class="primary--text subtitle-1 font-italic font-weight-light"
                                >{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.publish'
                                  )
                                }}</span
                              >
                              <span
                                v-else
                                class="font-italic subtitle-1 font-weight-light"
                                >{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.disable'
                                  )
                                }}</span
                              >
                              <v-switch
                                inset
                                v-model="child2.active"
                                class="px-6"
                                color="primary"
                                @click="
                                  openDialogStatus(itemGroup, child, child2, 3)
                                "
                                :disabled="
                                  itemGroup.isUse == true ||
                                  itemGroup.active == false ||
                                  child.active == false ||
                                  child2.countCourse != 0 ||
                                  child2.countStudent != 0
                                "
                              ></v-switch>
                            </div>
                            <!-- <v-divider inset vertical class="mb-2 mx-1"></v-divider> -->
                            <v-menu offset-y>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  elevation="0"
                                  class="mb-0 body-2 text-primary text-capitalize"
                                  color="white"
                                >
                                  <!-- <v-icon left>mdi-cog</v-icon> -->
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.userGroupManagement.option'
                                    )
                                  }}
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  :disabled="child2.active == true"
                                  @click="
                                    openDialogChangeRoot(child, child2, 3)
                                  "
                                >
                                  <v-list-item-icon class="mr-2">
                                    <v-icon
                                      small
                                      :color="
                                        child2.active == true
                                          ? 'grey lighten-1'
                                          : ''
                                      "
                                      >mdi-arrow-split-horizontal</v-icon
                                    >
                                  </v-list-item-icon>

                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="font-weight-light subtitle-2"
                                      >{{
                                        $vuetify.lang.t(
                                          '$vuetify.userGroupManagement.changeRoot'
                                        )
                                      }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item
                                  @click="
                                    openDialog(
                                      child2._id,
                                      child2.title,
                                      child2,
                                      3
                                    )
                                  "
                                >
                                  <v-list-item-icon class="mr-2">
                                    <v-icon small>
                                      mdi-square-edit-outline
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="font-weight-light subtitle-2"
                                      >{{
                                        $vuetify.lang.t(
                                          '$vuetify.userGroupManagement.edit'
                                        )
                                      }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item
                                  :disabled="
                                    child2.child_User_Group.length != 0 ||
                                    child2.countCourse != 0 ||
                                    child2.countStudent != 0 ||
                                    child2.active == true
                                  "
                                  @click="deleteGroupDialog(child2._id)"
                                >
                                  <v-list-item-icon class="mr-2">
                                    <v-icon
                                      small
                                      :color="
                                        child2.child_User_Group.length != 0 ||
                                        child2.countCourse != 0 ||
                                        child2.countStudent != 0 ||
                                        child2.active == true
                                          ? 'grey lighten-1'
                                          : 'error'
                                      "
                                      >mdi-delete</v-icon
                                    >
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      :class="
                                        child2.child_User_Group.length != 0 ||
                                        child2.countCourse != 0 ||
                                        child2.countStudent != 0 ||
                                        child2.active == true
                                          ? 'font-weight-light subtitle-2'
                                          : 'font-weight-light subtitle-2 error--text'
                                      "
                                      >{{
                                        $vuetify.lang.t(
                                          '$vuetify.userGroupManagement.delete'
                                        )
                                      }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-row>
                        </v-list-item-action>
                      </v-list-item>
                    </div>
                  </draggable>
                  <!-- </template> -->

                  <!-- <v-divider class="ma-0"></v-divider> -->
                </div>
              </draggable>
            </div>
          </v-card>
        </div>
      </draggable>
    </v-card>

    <v-card
      class="mx-auto mb-5 mr-5 ml-5"
      outlined
      v-if="groups.length == 0"
      align="center"
    >
      <v-card-text>
        {{ $vuetify.lang.t('$vuetify.userGroupManagement.userGroupNotFound') }}
      </v-card-text>
    </v-card>

    <v-row class="justify-center">
      <v-btn
        elevation="0"
        @click="openDialog(null, '', null, 1)"
        class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $vuetify.lang.t('$vuetify.userGroupManagement.addGroup') }}
      </v-btn>
    </v-row>

    <!-- dailog -->
    <v-dialog v-model="editGroupDialog" persistent max-width="600px">
      <v-card class="font-weight-light">
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-account-network-outline</v-icon>
            {{ $vuetify.lang.t('$vuetify.userGroupManagement.editAddGroup') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <p>
                  {{
                    $vuetify.lang.t('$vuetify.userGroupManagement.groupName')
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-text-field
                  v-model="title"
                  outlined
                  class="font-weight-light"
                  clearable
                  :placeholder="
                    $vuetify.lang.t('$vuetify.userGroupManagement.groupNamePlH')
                  "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="closeDialog"
            >{{ $vuetify.lang.t('$vuetify.userGroupManagement.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
            :disabled="title == ''"
            @click="insertOrUpdateGroup"
            >{{ $vuetify.lang.t('$vuetify.userGroupManagement.save') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.userGroupManagement.deleteTitle')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.userGroupManagement.deleteBody')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="dialogDelete = false"
            >{{
              $vuetify.lang.t('$vuetify.learnerManagement.learnerList.cancel')
            }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="red"
            @click="deleteGroup"
            >{{
              $vuetify.lang.t('$vuetify.learnerManagement.learnerList.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.userGroupManagement.deleteAlert')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.userGroupManagement.deleteAlertBody')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogDeleteSuccess = false"
            >{{ $vuetify.lang.t('$vuetify.userGroupManagement.done') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{ $vuetify.lang.t('$vuetify.courseManagement.courseList.sorry') }}
        </v-card-title>
        <v-card-text>
          <div
            v-html="
              $vuetify.lang.t(
                '$vuetify.courseManagement.courseList.alertPermissionFunction'
              )
            "
          ></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="goBack()">
            {{ $vuetify.lang.t('$vuetify.courseManagement.courseList.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.learnerManagement.learnerList.confirmSuspend'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.learnerManagement.learnerList.suspendDetail'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="cancelStatus()"
            >{{
              $vuetify.lang.t('$vuetify.learnerManagement.learnerList.cancel')
            }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="red"
            @click="updateActiveGroup"
            >{{
              $vuetify.lang.t('$vuetify.learnerManagement.learnerList.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusActive" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.learnerManagement.learnerList.confirmActivate'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.learnerManagement.learnerList.activateDetail'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="cancelStatusActive()"
            >{{
              $vuetify.lang.t('$vuetify.learnerManagement.learnerList.cancel')
            }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light button-primary"
            @click="updateActiveGroup"
            >{{
              $vuetify.lang.t('$vuetify.learnerManagement.learnerList.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogChangeRoot" persistent max-width="600px">
      <template>
        <v-card tile>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-arrow-split-horizontal</v-icon
              >{{ $vuetify.lang.t('$vuetify.userGroupManagement.changeRoot') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon dark @click="closeDialogChangeRoot" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.tooltripClose'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-if="subLevelLocal != 1"
                  :label="$vuetify.lang.t('$vuetify.userGroupManagement.msg2')"
                  class="my-0 py-0"
                  v-model="assignRootGroup"
                  hide-details
                  @change="setValueRootGroup"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t('$vuetify.userGroupManagement.chooseGroup')
                  }}
                </p>
                <v-autocomplete
                  :disabled="assignRootGroup == true"
                  v-model="selectedRootGroup"
                  :items="rootGroup"
                  item-text="name"
                  outlined
                  height="40"
                  :placeholder="
                    $vuetify.lang.t('$vuetify.userGroupManagement.msg1')
                  "
                  background-color="white"
                >
                  <template v-slot:selection="data">
                    <v-item v-bind="data.attrs" :input-value="data.selected">{{
                      data.item.name
                    }}</v-item>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      class="ml-5"
                      @click="selectedRootToChangeGroup(data.item)"
                    >
                      <v-list-item-title
                        v-text="data.item.name"
                      ></v-list-item-title>
                      <v-list-item-subtitle>
                        {{ data.item.countCourse }}
                        {{
                          $vuetify.lang.t('$vuetify.userGroupManagement.course')
                        }}
                        / {{ data.item.countStudent }}
                        {{
                          $vuetify.lang.t(
                            '$vuetify.userGroupManagement.learner'
                          )
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              @click="closeDialogChangeRoot"
              >{{
                $vuetify.lang.t('$vuetify.userGroupManagement.cancel')
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              :disabled="
                selectedRootGroup.length == 0 && assignRootGroup == false
              "
              @click="changeRootUserGroup"
              >{{ $vuetify.lang.t('$vuetify.userGroupManagement.save') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <!-- </v-card> -->
  </div>
</template>

<script>
import {
  insertUserGroup,
  setUserGroup,
  getUserGroupAdmin,
  deleteUserGroup,
  updateUserGroup,
  updateActiveUserGroup,
  setRootUserGroup,
} from '@/service/account/manageUserGroup';
import $ from 'jquery';
import { getUserList } from '../../service/account/manageUser';
export default {
  data: () => ({
    dialogDelete: false,
    dialogDeleteSuccess: false,
    groupId: '',
    groups: [],
    groups2: [
      // {
      //   title: "A",
      //   active: true,
      //   child_User_Group: [
      //     {
      //       title: "A-A",
      //       child_User_Group: [],
      //       active: true,
      //     }
      //   ]
      // },
      // {
      //   title: "B",
      //   child_User_Group: [
      //     {
      //       title: "B-A",
      //       child_User_Group: []
      //     }
      //   ]
      // }
    ],
    enabled: true,
    dragging: false,
    editGroupDialog: false,
    editGroup: false,
    title: '',
    id: null,
    oldGroup: null,
    alert: false,
    levelSub: null,
    dialogStatus: false,
    dialogStatusActive: false,
    tempItem: [],
    dialogChangeRoot: false,
    indexItem1: null,
    indexItem2: null,
    indexItem3: null,
    updateActive: null,
    rootGroup: [],
    selectedRootGroup: [],
    groupToChange: [],
    changeToRoot: [],
    oldRootGroup: [],
    assignRootGroup: false,
    subLevelLocal: 1,
  }),

  async mounted() {
    this.initialize();
    // console.log(this.$store.state);
    // let result = await getUserGroup()
    // this.groups2 = result
    // console.log(result)
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    editGroupDialog(newValue) {
      if (newValue) {
        if (this.id === null) {
          this.title = '';
        }
      }
    },
  },
  computed: {
    nameRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t('$vuetify.userGroupManagement.groupNameRules'),
      ];
    },
  },
  methods: {
    async initialize() {
      if (this.$store.state.permission.viewUserGroup) {
        await this.getListUserGroup();
      } else {
        this.noPermission();
      }
    },
    async getListUserGroup() {
      let result = await getUserGroupAdmin();
      console.log(result);
      this.groups2 = await result.filter((group) => group.active === true);
      // this.groups = await result.filter((group) => group.active === false);
      this.groups = await result;

      if (this.groups.length > 0) {
        this.groups.forEach((item, idx) => {
          let sumCourse = item.countCourse;
          let sumStudent = item.countStudent;
          item.child_User_Group.forEach((item_ch) => {
            sumCourse += item_ch.countCourse;
            sumStudent += item_ch.countStudent;
          });
          this.groups[idx]['totalCourse'] = sumCourse;
          this.groups[idx]['totalStudent'] = sumStudent;
        });
      }
      //   this.groups2 = [];
      //   this.groups = await result;
      //   result.forEach((element) => {
      //       let obj = [];
      //       if(element.child_User_Group){
      //           element.child_User_Group.forEach(child => {
      //               obj.push({
      //                   ...child,
      //                   name: element.title,
      //                   children: element.child_User_Group,
      //               });
      //           });
      //       }
      //       this.groups.push({
      //       ...element,
      //       name: element.title,
      //       children: element.child_User_Group,
      //     });
      //   });

      console.log(this.groups2);
      console.log(this.groups);
    },
    openExpand(id) {
      let panel = $('#expand-' + id);
      let btn = $('#centerx-ele-' + id);
      btn.attr('disabled', true);
      if (panel.hasClass('active')) {
        panel.slideUp('slow');
        panel.removeClass('active');
        btn.removeClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      } else {
        panel.slideDown('slow');
        panel.addClass('active');
        btn.addClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      }
    },
    closeDialogChangeRoot() {
      this.dialogChangeRoot = false;
      this.selectedRootGroup = [];
      this.assignRootGroup = false;
    },

    async openDialogChangeRoot(oldRoot, childGroup, levelSub) {
      console.log('Root เก่า ', oldRoot);
      console.log('ที่ต้องการย้าย ', childGroup);
      this.subLevelLocal = levelSub;
      this.dialogChangeRoot = true;
      this.oldRootGroup = oldRoot;
      this.groupToChange = childGroup;
      let result = [];
      this.rootGroup = [];
      let rootFilter = [];
      let childFilter = [];
      switch (levelSub) {
        case 1:
          result = await getUserGroupAdmin();
          rootFilter = await result.filter((group) => group.levelSub == 1);
          childFilter = await rootFilter.filter(
            (child) => child.child_User_Group.length > 0
          );
          this.rootGroup.push({
            header: this.$vuetify.lang.t(
              '$vuetify.userGroupManagement.groupLevel1'
            ),
          });
          rootFilter.forEach((root) => {
            if (childGroup._id != root._id)
              //Hide it self
              this.rootGroup.push({
                ...root,
                name: root.title,
              });
          });
          this.rootGroup.push({
            divider: true,
          });
          this.rootGroup.push({
            header: this.$vuetify.lang.t(
              '$vuetify.userGroupManagement.groupLevel2'
            ),
          });
          childFilter.forEach((childgroup) => {
            childgroup.child_User_Group.forEach((child2) => {
              this.rootGroup.push({
                ...child2,
                name: child2.title,
              });
            });
          });
          this.rootGroup.push({
            divider: true,
          });
          break;
        case 2:
          result = await getUserGroupAdmin();
          result.filter((group) => group.levelSub === 1);
          result.forEach((root) => {
            //If childGroup in root group hide root group in the list
            let childInThisRoot = false;
            root.child_User_Group.forEach((rootChild) => {
              if (rootChild._id == childGroup._id) {
                childInThisRoot = true;
              }
            });
            if (!childInThisRoot) {
              this.rootGroup.push({
                ...root,
                name: root.title,
              });
            }
          });
          break;
        case 3:
          result = await getUserGroupAdmin();
          rootFilter = await result.filter((group) => group.levelSub == 1);
          childFilter = await rootFilter.filter(
            (child) => child.child_User_Group.length > 0
          );
          this.rootGroup.push({
            header: this.$vuetify.lang.t(
              '$vuetify.userGroupManagement.groupLevel1'
            ),
          });
          rootFilter.forEach((root) => {
            this.rootGroup.push({
              ...root,
              name: root.title,
            });
          });
          this.rootGroup.push({
            divider: true,
          });
          this.rootGroup.push({
            header: this.$vuetify.lang.t(
              '$vuetify.userGroupManagement.groupLevel2'
            ),
          });
          childFilter.forEach((childgroup) => {
            childgroup.child_User_Group.forEach((child2) => {
              //If childGroup in root group hide root group in the list
              let childInThisRoot = false;
              child2.child_User_Group.forEach((rootChild) => {
                if (rootChild._id == childGroup._id) {
                  childInThisRoot = true;
                }
              });
              if (!childInThisRoot) {
                this.rootGroup.push({
                  ...child2,
                  name: child2.title,
                });
              }
            });
          });
          this.rootGroup.push({
            divider: true,
          });
          break;
      }
    },
    selectedRootToChangeGroup(selectRoot) {
      console.log('ย้ายไปที่นี่ ', selectRoot);
      this.changeToRoot = selectRoot;
    },
    setValueRootGroup() {
      if (this.assignRootGroup == true) {
        this.selectedRootGroup = [];
      }
    },
    async changeRootUserGroup() {
      if (this.assignRootGroup == false) {
        let index = this.oldRootGroup.child_User_Group.indexOf(
          this.groupToChange
        );
        console.log(index);
        this.oldRootGroup.child_User_Group.splice(index, 1);
        this.changeToRoot.child_User_Group.push(this.groupToChange);
        console.log('พุตแล้ว ', this.changeToRoot);
        console.log('หลังจากย้าย ', this.oldRootGroup);

        if (
          this.groupToChange.levelSub == 3 &&
          this.changeToRoot.levelSub == 1
        ) {
          let result = await updateUserGroup({
            id: this.groupToChange._id,
            title: this.groupToChange.title,
            countCourse: this.groupToChange.countCourse,
            countStudent: this.groupToChange.countStudent,
            levelSub: 2,
            active: this.groupToChange.active,
          });
        }
        if (
          this.groupToChange.levelSub == 1 &&
          this.changeToRoot.levelSub == 1
        ) {
          let result = await updateUserGroup({
            id: this.groupToChange._id,
            title: this.groupToChange.title,
            countCourse: this.groupToChange.countCourse,
            countStudent: this.groupToChange.countStudent,
            levelSub: 2,
            active: this.groupToChange.active,
          });
        }
        if (
          this.groupToChange.levelSub == 1 &&
          this.changeToRoot.levelSub == 2
        ) {
          let result = await updateUserGroup({
            id: this.groupToChange._id,
            title: this.groupToChange.title,
            countCourse: this.groupToChange.countCourse,
            countStudent: this.groupToChange.countStudent,
            levelSub: 3,
            active: this.groupToChange.active,
          });
        }
        let setGroupResult = await setUserGroup({
          id: this.changeToRoot._id,
          child_User_Group: this.changeToRoot.child_User_Group.map(
            (child) => child._id
          ),
        });
        console.log(setGroupResult);
        console.log('---', this.oldRootGroup);
        if (this.groupToChange.levelSub != 1) {
          let setGroupResult2 = await setUserGroup({
            id: this.oldRootGroup._id,
            child_User_Group: this.oldRootGroup.child_User_Group.map(
              (child) => child._id
            ),
          });
          console.log(setGroupResult2);
        }

        this.closeDialogChangeRoot();
        this.initialize();
        // end if
      } else {
        //assign group to root
        let index = this.oldRootGroup.child_User_Group.indexOf(
          this.groupToChange
        );
        console.log(index);
        this.oldRootGroup.child_User_Group.splice(index, 1);
        let result = await updateUserGroup({
          id: this.groupToChange._id,
          title: this.groupToChange.title,
          countCourse: this.groupToChange.countCourse,
          countStudent: this.groupToChange.countStudent,
          levelSub: 1,
          active: this.groupToChange.active,
        });
        if (this.groupToChange.child_User_Group) {
          this.groupToChange.child_User_Group.forEach(async (setchild) => {
            let result = await updateUserGroup({
              id: this.groupToChange._id,
              title: this.groupToChange.title,
              countCourse: this.groupToChange.countCourse,
              countStudent: this.groupToChange.countStudent,
              levelSub: 2,
              active: this.groupToChange.active,
            });
          });
        }
        let setGroupResult = await setUserGroup({
          id: this.groupToChange._id,
          child_User_Group: this.groupToChange.child_User_Group.map(
            (child) => child._id
          ),
        });
        let setGroupResult2 = await setUserGroup({
          id: this.oldRootGroup._id,
          child_User_Group: this.oldRootGroup.child_User_Group.map(
            (child) => child._id
          ),
        });
        let groupsID = [];
        this.groups.forEach(async (arrid) => {
          await groupsID.push(arrid._id);
        });
        await groupsID.push(this.groupToChange._id);

        await this.reorderRootGroup(groupsID);
        console.log(setGroupResult2);
        this.closeDialogChangeRoot();
        this.initialize();
      }
    },
    cancelStatus() {
      switch (this.levelSub) {
        case 1:
          this.groups[this.indexItem1].active = this.updateActive;
          break;
        case 2:
          this.groups[this.indexItem1].child_User_Group[
            this.indexItem2
          ].active = this.updateActive;
          break;
        case 3:
          this.groups[this.indexItem1].child_User_Group[
            this.indexItem2
          ].child_User_Group[this.indexItem3].active = this.updateActive;
          break;
      }
      this.dialogStatus = false;
    },
    cancelStatusActive() {
      switch (this.levelSub) {
        case 1:
          this.groups[this.indexItem1].active = this.updateActive;
          break;
        case 2:
          this.groups[this.indexItem1].child_User_Group[
            this.indexItem2
          ].active = this.updateActive;
          break;
        case 3:
          this.groups[this.indexItem1].child_User_Group[
            this.indexItem2
          ].child_User_Group[this.indexItem3].active = this.updateActive;
          break;
      }
      this.dialogStatusActive = false;
    },
    openDialogStatus(item1, item2, item3, levelSub) {
      let index1 = null;
      let index2 = null;
      let index3 = null;
      this.levelSub = levelSub;
      if (item1) {
        index1 = this.groups.indexOf(item1);
        this.tempItem1 = item1;
      }
      if (item2) {
        index2 = this.groups[index1].child_User_Group.indexOf(item2);
        this.tempItem2 = item2;
      }
      if (item3) {
        index3 = this.groups[index1].child_User_Group[
          index2
        ].child_User_Group.indexOf(item3);
        this.tempItem3 = item3;
      }
      this.indexItem1 = index1;
      this.indexItem2 = index2;
      this.indexItem3 = index3;
      console.log('level 1 : ', this.levelSub, this.tempItem1);
      console.log('level 2 : ', this.levelSub, this.tempItem2);
      console.log('level 3 : ', this.levelSub, this.tempItem3);
      switch (this.levelSub) {
        case 1:
          if (this.groups[index1].active == true) {
            this.dialogStatus = true;
            this.updateActive = this.groups[index1].active;
          } else {
            this.dialogStatusActive = true;
            this.updateActive = this.groups[index1].active;
          }
          break;
        case 2:
          if (this.groups[index1].child_User_Group[index2].active == true) {
            this.dialogStatus = true;
            this.updateActive = this.groups[index1].child_User_Group[
              index2
            ].active;
          } else {
            this.dialogStatusActive = true;
            this.updateActive = this.groups[index1].child_User_Group[
              index2
            ].active;
          }
          break;
        case 3:
          if (
            this.groups[index1].child_User_Group[index2].child_User_Group[
              index3
            ].active == true
          ) {
            this.dialogStatus = true;
            this.updateActive = this.groups[index1].child_User_Group[
              index2
            ].child_User_Group[index3].active;
          } else {
            this.dialogStatusActive = true;
            this.updateActive = this.groups[index1].child_User_Group[
              index2
            ].child_User_Group[index3].active;
          }
          break;
      }
    },
    async updateActiveGroup() {
      console.log(this.updateActive);
      switch (this.levelSub) {
        case 1:
          if (this.updateActive == true) {
            let status = await updateActiveUserGroup({
              id: this.tempItem1._id,
              active: false,
            });

            if (this.tempItem1.child_User_Group) {
              this.tempItem1.child_User_Group.forEach(async (group) => {
                let status = await updateActiveUserGroup({
                  id: group._id,
                  active: false,
                });
                if (group.child_User_Group) {
                  console.log('groupChild');
                  group.child_User_Group.forEach(async (groupChild) => {
                    let status = await updateActiveUserGroup({
                      id: groupChild._id,
                      active: false,
                    });
                  });
                  this.initialize();
                }
              });
              this.initialize();
            }
            this.dialogStatus = false;
            this.dialogSuccess = true;
            this.initialize();
            return status;
          } else {
            let status = await updateActiveUserGroup({
              id: this.tempItem1._id,
              active: true,
            });
            this.dialogStatusActive = false;
            this.dialogSuccess = true;
            this.initialize();
            return status;
          }
          break;
        case 2:
          if (this.updateActive == true) {
            let status = await updateActiveUserGroup({
              id: this.tempItem2._id,
              active: false,
            });
            if (this.tempItem2.child_User_Group) {
              this.tempItem2.child_User_Group.forEach(async (group) => {
                let status = await updateActiveUserGroup({
                  id: group._id,
                  active: false,
                });
              });
              this.initialize();
            }
            this.dialogStatus = false;
            this.dialogSuccess = true;
            this.initialize();
            return status;
          } else {
            let status = await updateActiveUserGroup({
              id: this.tempItem2._id,
              active: true,
            });
            this.dialogStatusActive = false;
            this.dialogSuccess = true;
            this.initialize();
            return status;
          }
          break;
        case 3:
          if (this.updateActive == true) {
            let status = await updateActiveUserGroup({
              id: this.tempItem3._id,
              active: false,
            });
            this.dialogStatus = false;
            this.dialogSuccess = true;
            this.initialize();
            return status;
          } else {
            let status = await updateActiveUserGroup({
              id: this.tempItem3._id,
              active: true,
            });
            this.dialogStatusActive = false;
            this.dialogSuccess = true;
            this.initialize();
            return status;
          }
          break;
      } // end switch case
    },

    async checkMoveRootGroup() {
      let groupsID = this.groups.map((group) => group._id);
      this.reorderRootGroup(groupsID);
    },
    async reorderRootGroup(groupsId) {
      console.log(groupsId);
      await setRootUserGroup({
        arrayIdGroup: groupsId,
      });
    },
    async checkMoveGroup() {
      console.log(this.groups2);
      console.log(this.groups);

      //group temp
      for (let i = 0; i < this.groups.length; i++) {
        // let result = await updateUserGroup({
        //   ...this.groups[i],
        //   id: this.groups[i]._id,
        //   title: this.groups[i].title,
        //   countCourse: this.groups[i].countCourse,
        //   countStudent: this.groups[i].countStudent,
        //   levelSub: 1,
        //   active: false,
        // });
        // this.groups[i].id = result._id;
        // this.groups[i].levelSub = 1;
        // console.log("i", i, result);
        for (let j = 0; j < this.groups[i].child_User_Group.length; j++) {
          // let result = await updateUserGroup({
          //   ...this.groups[i].child_User_Group[j],
          //   id: this.groups[i].child_User_Group[j]._id,
          //   title: this.groups[i].child_User_Group[j].title,
          //   countCourse: this.groups[i].child_User_Group[j].countCourse,
          //   countStudent: this.groups[i].child_User_Group[j].countStudent,
          //   levelSub: 2,
          //   active: false,
          // });
          // this.groups[i].child_User_Group[j]._id = result._id;
          // this.groups[i].child_User_Group[j].levelSub = 2;
          // console.log("j", j, result);
          for (
            let k = 0;
            k < this.groups[i].child_User_Group[j].child_User_Group.length;
            k++
          ) {
            // let result = await updateUserGroup({
            //   ...this.groups[i].child_User_Group[j].child_User_Group[k],
            //   id: this.groups[i].child_User_Group[j].child_User_Group[k]._id,
            //   title: this.groups[i].child_User_Group[j].child_User_Group[k].title,
            //   countCourse: this.groups[i].child_User_Group[j].child_User_Group[k]
            //     .countCourse,
            //   countStudent: this.groups[i].child_User_Group[j].child_User_Group[k]
            //     .countStudent,
            //   levelSub: 3,
            //   active: false,
            // });
            // this.groups[i].child_User_Group[j].child_User_Group[k]._id = result._id;
            // this.groups[i].child_User_Group[j].child_User_Group[k].levelSub = 3;
            // console.log("k", k, result);
          }
          if (this.groups[i].child_User_Group[j].child_User_Group.length > 0) {
            let setGroupResult = await setUserGroup({
              id: this.groups[i].child_User_Group[j]._id,
              child_User_Group: this.groups[i].child_User_Group[
                j
              ].child_User_Group.map((child) => child._id),
            });
            console.log(setGroupResult);
          }
        }
        if (this.groups[i].child_User_Group.length > 0) {
          let setGroupResult = await setUserGroup({
            id: this.groups[i]._id,
            child_User_Group: this.groups[i].child_User_Group.map(
              (child) => child._id
            ),
          });
          console.log(setGroupResult);
        }
      }
      console.log(this.groups2);
    },
    async deleteGroupDialog(id) {
      this.dialogDelete = true;
      this.groupId = id;
    },
    async deleteGroup() {
      let result = await deleteUserGroup({
        id: this.groupId,
      });
      console.log(result);
      this.dialogDelete = false;
      this.dialogDeleteSuccess = true;
      this.groupId = '';
      this.initialize();
    },
    async insertOrUpdateGroup() {
      if (this.title != '') {
        if (this.id !== null) {
          if (this.levelSub == this.oldGroup.levelSub) {
            let result = await updateUserGroup({
              ...this.oldGroup,
              id: this.id,
              title: this.title,
            });
            console.log(result);
            // this.title = ''
            // this.id = null
          } else {
            let result = await insertUserGroup({
              title: this.title,
              levelSub: this.levelSub,
              active: this.oldGroup.active,
            });
            console.log(result);
            let arrid = [];
            this.oldGroup.child_User_Group.forEach((group) => {
              arrid.push(group._id);
            });
            arrid.push(result._id);
            console.log(arrid);
            let setGroupResult = await setUserGroup({
              id: this.oldGroup._id,
              child_User_Group: arrid,
            });
            console.log(setGroupResult);
          }
        } else {
          // this.groups.push({ title: this.title, child_User_Group: [] });
          // this.title = "";
          let result = await insertUserGroup({
            title: this.title,
            levelSub: 1,
            active: true,
          });
          console.log(result);
        }
        this.title = '';
        this.id = null;
        this.oldGroup = null;
        this.levelSub = null;
        this.closeDialog();
        await this.initialize();
      }
      // this.editGroupDialog = true
    },
    async openDialog(id, title, oldGroup, levelSub) {
      this.levelSub = levelSub;
      if (id !== null) {
        this.title = title;
        this.id = id;
        this.oldGroup = oldGroup;
        console.log(oldGroup);
      } else {
        this.title = '';
        this.id = null;
      }
      this.editGroupDialog = true;
    },
    async closeDialog() {
      this.editGroupDialog = false;
      this.title = '';
    },
    noPermission() {
      this.alert = true;
    },
    goBack() {
      this.alert = false;
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.main {
  background-color: rgb(241, 243, 245);
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  background: white;
  transition: transform 0.3s ease-in-out;
}

.item-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  background: white;
  transition: transform 0.3s ease-in-out;
}

.img-center {
  margin: 0 auto;
}

/* .paddingLeft {
  padding-left: 50px;
} */
/* .v-card > :last-child:not(.v-btn):not(.v-chip) {
  margin-left: 50px;
} */

.card-list {
  margin-bottom: 20px;
  background: #f2f3f5 !important;
}

.list-group {
  margin-top: 15px;
  min-height: 15px;
}

.paddingLeft > .theme--light.v-toolbar.v-sheet {
  height: 50px !important;
}

.paddingLeft > .theme--light.v-toolbar.v-sheet > .v-toolbar__content,
.v-toolbar__extension {
  height: 50px !important;
}

.fixed-heght {
  height: 30px;
}

.rounded-card {
  border-radius: 8px;
}

.theme--light.v-card.v-card--outlined {
  /* border: thin solid rgba(0,0,0,.12); */
  border-width: 0;
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}

.v-input__append-inner {
  margin-top: 9px !important;
}

.md-fixed-max-width {
  max-width: 150px;
}

.tempGroup {
  border-style: dotted;
  border-width: 3px;
  border-color: skyblue;
}

.expand-panel {
  margin-top: 20px;
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lesson-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 0px 0px 15px 15px;
  transition: transform 0.3s ease-in-out;
}
.card-custom-lecture {
  /* box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19) !important;
  transition: transform 0.3s ease-in-out !important; */
  border-radius: 2px 2px 0 0 !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-bottom: 0 !important;
  background: #eeeeee !important;
}
.card-child-lecture {
  border-radius: 0 0 2px 2px !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-top: 0 !important;
  background: white !important;
}

.card-bg {
  background: transparent;
}
.md-position-relative {
  position: relative !important;
}

.md-position-absolute {
  position: absolute;
}

.centerx-ele {
  left: 50%;
  transform: translate(-50%, 0);
  top: 0;
}

.centerx-ele.active .icon {
  transform: rotate(180deg);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

@media only screen and (max-width: 768px) {
  .hiddex-xs {
    /* display: none; */
  }

  .xs-full-max-width {
    max-width: 100%;
  }

  .table-header {
    height: auto !important;
  }

  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column;
    padding: 0 !important;
  }

  .xs-full-width {
    width: 50%;
  }
}
</style>
